// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Angular
import { SmsValidationComponent } from './sms-validation.component';
import { CardModule } from 'libraries/ui_card/card.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { BackButtonModule } from 'app_sasha/shared/components/back-button/back-button.module';
import { LoaderModule } from 'libraries/component/loader/loader.module';
import { NotificationModule } from 'libraries/component/notification/notification.module';
import { ProcessingValidationModule } from 'app_sasha/shared/components/processing-validation/processing-validation.module';
import { ProcessingSmsResourceModule } from 'app_sasha/shared/resources/processing-sms-resource/processing-sms-resource.module';
import { BreadcrumbModule } from 'libraries/component/breadcrumb/breadcrumb.module';
import { TitleServiceModule } from 'app_sasha/shared/services/title/title-service.module';

@NgModule({
    declarations: [
        SmsValidationComponent,
    ],
    imports: [
        CommonModule,
        BreadcrumbModule,
        CardModule,
        BtnModule,
        BackButtonModule,
        LoaderModule,
        NotificationModule,
        ProcessingValidationModule,
        ProcessingSmsResourceModule,
        TitleServiceModule,
    ],
    exports: [
        SmsValidationComponent,
    ],
    providers: [],
})
export class SmsValidationModule { }